export const TRUSTED_APP_RATING_ORG_LOGO_IDENTIFIER = '__ORG_LOGO__'
